import { Api } from "./api"

export class CupperApi extends Api {
  constructor() {
    super('cuppers', ['email', 'message'])
  }
}
